import { render, staticRenderFns } from "./FormModals.vue?vue&type=template&id=4c0c62de&scoped=true&"
import script from "./FormModals.vue?vue&type=script&lang=js&"
export * from "./FormModals.vue?vue&type=script&lang=js&"
import style0 from "./FormModals.vue?vue&type=style&index=0&id=4c0c62de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c62de",
  null
  
)

export default component.exports